import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { RmpvOficinaMensalFiltroComponent } from './rmpv-oficina-mensal-filtro/rmpv-oficina-mensal-filtro.component';
import { RmpvOficinaMensalComponent } from './rmpv-oficina-mensal.component';
import { RmpvOficinaMensalService } from './service/rmpv-oficina-mensal.service';


@NgModule({
  imports: [
    CommonModule,
    ComumModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    ChartsModule,
    HttpClientModule,
    NgbModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  providers: [
    RmpvOficinaMensalService
  ],
  exports:[
    RmpvOficinaMensalComponent
  ],
  declarations: [
    RmpvOficinaMensalComponent,
    RmpvOficinaMensalFiltroComponent
  ]
})
export class RmpvOficinaMensalModule { }
